import { CheckCircleFilled } from '@ant-design/icons';
import type { MediaRow } from '../../api/client';
import { fmtTaipei } from '../../pages/article-list/status';

interface Props {
  items: MediaRow[];
  pickedId: string | null;
  onPick: (item: MediaRow) => void;
}

/** 挑圖用的縮圖格線：單選，選中的加外框與勾勾。捲動交給外層 Drawer，這裡不另設高度。 */
export default function PickerGrid({ items, pickedId, onPick }: Props) {
  return (
    <div className="grid grid-cols-3 gap-2 sm:grid-cols-4 md:grid-cols-6 md:gap-3">
      {items.map((m) => {
        const on = m.id === pickedId;
        const when = m.publishedAt ?? m.createdAt;
        return (
          <button
            key={m.id}
            type="button"
            onClick={() => onPick(m)}
            className={`relative overflow-hidden rounded-lg text-left ring-1 transition ${
              on ? 'ring-2 ring-[#dd7900]' : 'ring-black/5 hover:ring-[#dd7900]/40'
            }`}
          >
            <div className="aspect-square bg-gray-50">
              <img
                src={m.url}
                alt={m.alt ?? ''}
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="truncate px-1.5 py-1 text-[11px] text-gray-500">
              {fmtTaipei(when).slice(0, 10)}
            </div>
            {on && (
              <CheckCircleFilled className="absolute right-1.5 top-1.5 text-lg text-[#dd7900] drop-shadow" />
            )}
          </button>
        );
      })}
    </div>
  );
}
